import type { OptionMenuItem } from '@getaccept/lib-shared/src/options-menu/types/option-menu-item';
import {
  CellType,
  NodeType,
  TextType,
  RowType,
  FieldInputType,
} from '@getaccept/editor-lib/src/types/enums';
import type { DropdownItem } from '../types';

export const addNodeItems: (OptionMenuItem & { isParent?: boolean })[] = [
  {
    icon: 'link',
    title: 'link',
    callback: NodeType.Link,
  },
  {
    icon: 'document-play',
    title: 'video',
    callback: NodeType.Video,
  },
  {
    icon: 'text',
    title: 'text',
    callback: NodeType.Text,
  },
  {
    icon: 'image',
    title: 'image',
    callback: NodeType.Image,
  },
  {
    icon: 'column-sidebyside',
    title: 'image-and-text',
    callback: RowType.SideBySide,
  },
  {
    icon: 'columns',
    title: 'columns-layout',
    callback: RowType.Columns,
  },
  {
    icon: 'table',
    title: 'table',
    callback: NodeType.Table,
  },
  {
    icon: 'text-divider',
    title: 'divider',
    callback: NodeType.Divider,
  },
  {
    icon: 'form',
    title: 'form',
    callback: NodeType.Form,
    isParent: true,
  },
  {
    icon: 'coins',
    title: 'pricing-table',
    callback: NodeType.PricingTable,
  },
  {
    icon: 'signature',
    title: 'signature',
    callback: NodeType.Signature,
  },
];

export const markdownTextTypeItems: DropdownItem[] = [
  {
    text: 'normal-text',
    itemClass: 'paragraph',
    type: TextType.Paragraph,
  },
  {
    text: 'heading-1',
    itemClass: 'heading1',
    type: TextType.Heading1,
  },
  {
    text: 'heading-2',
    itemClass: 'heading2',
    type: TextType.Heading2,
  },
  {
    text: 'subheading',
    itemClass: 'subheading',
    type: TextType.Subheading,
  },
];

export const textTypeItems: DropdownItem[] = [
  ...markdownTextTypeItems,
  {
    text: 'small-text',
    itemClass: 'label',
    type: TextType.Label,
  },
];

export const cellTypeIcon = {
  [CellType.ImageOnly]: 'column-image-only',
  [CellType.TextOnly]: 'column-text-only',
  [CellType.ImageAndText]: 'column-image-and-text',
};

export const formInputTypes: OptionMenuItem[] = [
  {
    icon: 'form',
    title: 'text-input',
    callback: FieldInputType.Text,
  },
  {
    icon: 'checkbox',
    title: 'checkbox',
    callback: FieldInputType.Checkbox,
  },
  {
    icon: 'dropdown',
    title: 'dropdown',
    callback: FieldInputType.Dropdown,
  },
];

export const BACK_TO_ROOT_CREATE_MENU = 'back-to-root-create-menu';
